import axios from 'axios';
import { getConfig } from '../config/apiConfig';

const getAnalyticsConfiguration = async (isinSite) => {
  // Get auth header config
  const config = await getConfig();
  const url = `api/webanalytics/webanalyticsdetails/inSite/${isinSite}`;

  return axios
    .get(url, config)
    .then(async (resp) => {
      let response = {};
      if (resp.data) {
        response = resp.data;
      }
      return response;
    })
    .catch((err) => {
      throw err.response;
    });
};

export default getAnalyticsConfiguration;
